import { Checkbox, ListItemText } from "@material-ui/core";
import {
  IntegrationType,
  useGetLmsIntegrationsForReportQuery,
} from "../../../generated/graphql";
import { LmsMenuItem, LmsSelect } from "./styles";

interface LmsFilterProps {
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

// Multi-select over the LMS-type integrations (Moodle, Canvas, ...). Nothing selected = every LMS,
// shown as "all ticked" so the closed control reads the same either way.
export const LmsFilter = ({ selectedIds, onChange }: LmsFilterProps) => {
  const { data } = useGetLmsIntegrationsForReportQuery({
    fetchPolicy: "cache-and-network",
  });

  const lmsList = (data?.getIntegrationsForAdmin || []).filter(
    (integration) => integration?.type === IntegrationType.Lms
  );
  const allIds = lmsList.map(({ id }) => id);
  const isAll = selectedIds.length === 0;

  const label = isAll
    ? "LMS: усі"
    : `LMS: ${lmsList
        .filter(({ id }) => selectedIds.includes(id))
        .map(({ name }) => name)
        .join(", ")}`;

  return (
    <LmsSelect
      multiple
      displayEmpty
      variant="outlined"
      value={isAll ? allIds : selectedIds}
      renderValue={() => label}
      onChange={(e) => {
        const values = e.target.value as string[];

        // With exactly one LMS in the system, "selected" and "nothing selected" both mean "show
        // that one LMS" (empty = all), so unchecking it would immediately re-tick itself. Treat
        // it as a no-op instead of letting the checkbox flicker back on.
        if (allIds.length === 1 && values.length === 0) {
          return;
        }

        onChange(values.length === allIds.length ? [] : values);
      }}
    >
      {lmsList.map(({ id, name }) => (
        <LmsMenuItem key={id} value={id}>
          <Checkbox checked={isAll || selectedIds.includes(id)} />
          <ListItemText primary={name} />
        </LmsMenuItem>
      ))}
    </LmsSelect>
  );
};
